<template>
  <div class="py--xl">
    <dara-header size="md">{{ $t('sorry') }}</dara-header>
    <dara-header>{{ $t('permission-denied') }}</dara-header>
    <p>
      {{ $t('you-dont-have-access-to-this-page-or') }}
      <br />
      {{ $t('your-session-has-expired') }}
    </p>
    <dara-button class="btn btn-primary" @click="goToLoginPage()">
      {{ $t('back-to-login') }}
    </dara-button>
  </div>
</template>

<script>
import { goToLoginPage } from '@/router/route.service';
import { setLanguage, getCookieLanguage } from '@/services/translate.service';

export default {
  name: 'DaraForbiddenPage',
  beforeMount() {
    this.changeLanguage(getCookieLanguage());
  },
  methods: {
    goToLoginPage,
    changeLanguage(language) {
      this.language = language;
      setLanguage(language);
    },
  },
};
</script>
